import { createServerFn } from "@tanstack/react-start";

/** Returns the public GA4 measurement ID (safe to expose; it appears in page HTML anyway). */
export const getAnalyticsId = createServerFn({ method: "GET" }).handler(async () => {
  const id = (process.env["GOOGLE_ANALYTICS_MEASUREMENT_ID"] ?? "").trim();
  return /^G-[A-Z0-9]+$/i.test(id) ? id : null;
});
